function swiperinitialized() {
    console.log('Swiper initialization function called');
    var swiperElement = document.querySelector('.mvidSwiper');
    if (!swiperElement) {
        console.error('Swiper element not found');
        return;
    }
    if (swiperElement.swiper) {
        console.log('Destroying existing Swiper instance');
        swiperElement.swiper.destroy(true, true);
    }

    var swiper = new Swiper(swiperElement, {
        slidesPerView: 1.3,
        spaceBetween: 10,
        loop:true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: { slidesPerView: 3, spaceBetween: 15 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
            1280: { slidesPerView: 5, spaceBetween: 25 },
        },     
        on: {
            init: function () {
                console.log('Swiper initialized');
            },
        }
    });
    document.querySelectorAll('.u-play-button-container').forEach(button => {
        button.addEventListener('click', function () {
            var videoElement = this.closest('.u-video-slider-video').querySelector('.vm-video');
            if (videoElement.paused) {
                videoElement.play();
                videoElement.muted = false;
                this.style.opacity = 0;
                console.log('Video playing');
            } else {
                videoElement.pause();
                this.style.opacity = 1; 
                console.log('Video paused');
            }
        });
    });
    document.querySelectorAll('.vm-video').forEach(video => {
        video.addEventListener('ended', function () {
            console.log('Video ended, replaying');
            video.play();
        });
    });

    console.log('Swiper and event listeners set up');
}


document.addEventListener('DOMContentLoaded', () => {
    let buttons = document.querySelectorAll('.u-faq-toggle');
    buttons.forEach((button) => {
        button.addEventListener('click', () => {
        let item = button.closest('.u-faq-item');
        let content = item.querySelector('.u-faq-content');
        if (item.classList.contains('active')) {
            item.classList.remove('active');
            content.style.maxHeight = 0;
        } else {
            item.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
        });
    });
});


document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.u-collapsible-toggle');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.u-collapsible-item');
      const content = item.querySelector('.u-collapsible-content');

      // Toggle active class
      item.classList.toggle('active');

      // Animate max-height
      if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = 0;
      }
    });
  });
});
